import { Handle, NodeToolbar, Position } from '@xyflow/react';
import React, { useState, useContext } from 'react'
import './CustomNodes.css';
import NodeToolbarOptionsMenu from './NodeToolbarOptionsMenu';
import { useDispatch } from 'react-redux';
import { treeActions } from '../../../redux/slices/treeSlice';
import { VisualWorkflowCopyPasteCtx } from '../ReactFlowContainer';

export const CustomNodes = (props) => {

    const { data, selected } = props;
    const dispatch = useDispatch();
    const contextValue = useContext(VisualWorkflowCopyPasteCtx);
    const { isCopied, setIsCopied } = contextValue || { 
        isCopied: { copy: false, paste: false }, 
        setIsCopied: () => {} 
    };

    const [showContextMenu, setShowContextMenu] = useState('');

    const baseNodeStyle = {
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    }

    const nodeSelectedStyle = {
        ...baseNodeStyle,
        border: "3px solid #1976d2",
        boxShadow: "0 0 0 3px rgba(25,118,210,0.1), 0 4px 12px rgba(25,118,210,0.3), 0 0 20px rgba(25,118,210,0.2)",
        // transform: "scale(1.02)",
        outline: "none",
    }

    function handleNodeClick(data) {
        dispatch(treeActions.setRightTreeSelectedNode({
            screen: 'workflow',
            type: 'body',
            data: data,
        }));
    }

    return (
        <>
        <NodeToolbar isVisible={showContextMenu === data?.id} position='right' offset={-10} onMouseLeave={() => setShowContextMenu('')}>
            <NodeToolbarOptionsMenu 
                nodeData={data?.data} 
                isCopied={isCopied} 
                setIsCopied={setIsCopied} 
            />
        </NodeToolbar>
        {data?.type === "START" ? 
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px', flex: 1, flexDirection: 'column', padding: '8px 16px',
            backgroundColor: "#469e42",
            borderRadius: '50%',
            justifyContent: 'center',
            textAlign: 'center',
            fontSize: '12px',
            border: selected ? '3px solid #1976d2' : '2px solid #000',
            fontWeight: '400',
            ...baseNodeStyle,
            ...(selected ? nodeSelectedStyle : {}),
         }}
         onClick={() => {
            handleNodeClick(data?.data);
         }}
         >
            <div title={data?.label} style={{ flex: 1, fontSize: '12px' }}>{data?.label}</div>
           <Handle type="source" className="handle" position={Position.Bottom} style={{ background: "transparent" }} />
           <Handle type="target" className="handle" position={Position.Top} style={{ background: "transparent" }} /> 
        </div>
        :
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px', flex: 1, flexDirection: 'column', padding: '8px 4px', 
            ...baseNodeStyle,
            ...(selected ? nodeSelectedStyle : {}) }}
            onContextMenu={(event) => {
                event.preventDefault();
                if (data?.data?.key) {
                    dispatch(treeActions.setRightTreeSelectedNode({
                        screen: 'workflow',
                        type: 'body',
                        data: data.data,
                    }));
                    dispatch(treeActions.setSelectedKeysArray({
                        screen: 'workflow',
                        type: 'body',
                        data: [data.data.key],
                    }));
                }
                setShowContextMenu(data?.id);
            }}
            onClick={() => {
                handleNodeClick(data?.data);
            }}
            >
            <span className={data?.type+"_NEW"} style={{ display: 'inline-block' }} />
            <div title={data?.label} style={{ flex: 1, fontSize: '12px' }}>{data?.label}</div>
            <Handle type="source" position={Position.Bottom} style={{ background: "transparent" }} />
            <Handle type="target" position={Position.Top} style={{ background: "transparent" }} />
        </div>
        }
        </>
    )
}

export default React.memo(CustomNodes, (prev, next) =>
    prev.data.label === next.data.label &&
    prev.selected === next.selected &&
    prev.data.type === next.data.type
  );